const CalibrationGeneralDictionary = {
    // Building Configuration
    PrincipalMaxHeightLvl: 'Principal Building Maximum Levels (Podium)',
    PrincipalBuildingMin: 'Principal Building Minimum Levels (Podium)',
    PrincipalMaxHeightFt: 'Principal Building Max. Height (Podium)',
    PrincipalMinHeightFt: 'Principal Building Minimum Height (Podium)',
    Outbuilding: 'Outbuilding Maximum Levels',
    ActivePrimaryFrontageGround: 'Active Principal Frontage Ground Level',
    ActivePrimaryFrontageAbove: 'Active Principal Frontage Above Ground',
    ActiveSecondaryFrontageGround: 'Active Secondary Frontage Ground Level',
    ActiveSecondaryFrontageAbove: 'Active Secondary Frontage Above Ground',
    ActiveWaterFrontageGround: 'Active Natural Feature Frontage Ground Level',
    ActiveWaterFrontageAbove: 'Active Natural Feature Frontage Above Ground',
    FacadePrimaryFrontage: 'Minimum Active Principal Frontage',
    FacadeSecondaryFrontage: 'Minimum Active Secondary Frontage',
    PkgFacadeWidthMax: 'Parking Entrance Maximum Width at Principal Frontage',
    TowerMaxHeightLvl: 'Tower Maximum Levels (Including Podium)',
    PenthouseMaxHeightLvl: 'Penthouse Maximum Levels (Including Podium and Tower)',
    TowerMaxHeightFt: 'Total Maximum Height (Including Podium, Tower and Pethouse)',

    // Lot Occupation
    LotAreaMin: 'Lot Area Minimum',
    LotAreaMax: 'Lot Area Maximum',
    LotAreaMinAlley: 'Lot Area Minimum Alley',
    LotAreaMaxAlley: 'Lot Area Maximum Alley',
    LotWidthMin: 'Lot Width Minimum',
    LotWidthMinAlley: 'Lot Width Minimum Alley',
    LotWidthMax: 'Lot Width Maximum',
    GreenSpace: 'Minimum Green Open Space',
    LotCoverageFirstFloor: 'Maximum Building Coverage',
    LotCoverageSecondFloor: 'Maximum Building Coverage 2nd Level',
    TowerFloorplateAreaResidential: 'Tower Floorplate Area Residential',
    TowerFloorplateAreaCommercial: 'Tower Floorplate Area Commercial',
    PenthouseFloorPlate: 'Penthouse Floorplate Area',
    SecondLayerDimension: 'Minimum Depth of Active Frontage',
    FLR: 'Global Floor Land Ratio (FLR)',

    // Setbacks - Principal
    PFrontSetbackPrincipal: 'Principal - Minimum Principal Frontage Setback',
    PFrontSetbackPrincipalMax: 'Principal - Maximum Principal Frontage Setback',
    PFrontSetbackSecondary: 'Principal - Minimum Secondary Frontage Setback',
    PFrontSetbackSecondaryMax: 'Principal - Maximum Secondary Frontage Setback',
    PWaterSetback: 'Principal - Minimum Natural Feature Frontage Setback',
    PSideSetback: 'Principal - Minimum Side Setback',
    PSideSetbackMax: 'Principal - Maximum Side Setback',
    PSplitSideSetback: 'Principal - Split Setback',
    PRearSetback: 'Principal - Minimum Rear Setback',
    PRearSetbackMax: 'Principal - Maximum Rear Setback',

    // Setbacks - Outbuilding
    OFrontSetbackPrincipal: 'Outbuilding - Minimum Principal Frontage Setback',
    OSideSetback: 'Outbuilding - Minimum Side Setback',
    OSideSetbackAtCorner: 'Outbuilding - Minimum Secondary Frontage Setback',
    ORearSetback: 'Outbuilding - Minimum Rear Setback',

    // Setbacks - Tower
    TFrontSetbackPrincipal: 'Tower - Minimum Principal Frontage Setback',
    TFrontSetbackPrincipalMax: 'Tower - Maximum Principal Frontage Setback',
    TFrontSetbackSecondary: 'Tower - Minimum Secondary Frontage Setback',
    TFrontSetbackSecondaryMax: 'Tower - Maximum Secondary Frontage Setback',
    TWaterSetback: 'Tower - Minimum Natural Feature Frontage Setback',
    TSideSetback: 'Tower - Minimum Side Setback',
    TSideSetbackMax: 'Tower - Maximum Side Setback',
    TRearSetback: 'Tower - Minimum Rear Setback',
    TRearSetbackMax: 'Tower - Maximum Rear Setback',
    TSetbackBetweenTowers: 'Tower - Setback between towers',

    // Setbacks - Penthouse
    PeFrontSetbackPrincipal: 'Penthouse - Minimum Principal Frontage Setback',
    PeFrontSetbackPrincipalMax: 'Penthouse - Maximum Principal Frontage Setback',
    PeFrontSetbackSecondary: 'Penthouse - Minimum Secondary Frontage Setback',
    PeFrontSetbackSecondaryMax: 'Penthouse - Maximum Secondary Frontage Setback',
    PeSideSetback: 'Penthouse - Minimum Side Setback',
    PeSideSetbackMax: 'Penthouse - Maximum Side Setback',
    PeRearSetback: 'Penthouse - Minimum Rear Setback',
    PeRearSetbackMax: 'Penthouse - Maximum Rear Setback',

    // Setbacks - Underground
    UFrontSetbackPrincipal: 'Underground - Minimum Principal Frontage Setback',
    UFrontSetbackSecondary: 'Underground - Minimum Secondary Frontage Setback',
    USideSetback: 'Underground - Minimum Side Setback',
    URearSetback: 'Underground - Minimum Rear Setback',

    // Private Frontages
    CommonLawn: 'Common Lawn',
    PorchAndFence: 'Porch and Fence',
    TerraceOrLightwell: 'Terrace or Lightwell',
    Forecourt: 'Forecourt',
    Stoop: 'Stoop',
    Shopfront: 'Shopfront',
    Gallery: 'Gallery',
    Arcade: 'Arcade',

    FrontageSplitSettingsSplitType: 'Split Type',
    FrontageSplitSettingsSmallestSetback: 'Smallest Setback',
    FrontageSplitSettingsOneMinimumSetback: 'One Minimum Setback'
};

export default CalibrationGeneralDictionary;
